import PropTypes from "prop-types";
import { Button } from "react-aria-components";

import { twMerge } from "../../../../../helpers/twMerge";
import { ArrowLeftIcon } from "../../../../assets/ArrowLeftIcon";

export const PreviousButton = ({ handlePrev, className, ...props }) => (
	<Button
		onPress={handlePrev}
		className={twMerge(
			"tw:absolute tw:left-0 tw:inline-flex tw:cursor-pointer tw:appearance-none tw:rounded-sm tw:align-middle tw:whitespace-nowrap tw:text-[#212121] tw:outline-hidden tw:transition-all tw:select-none tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:disabled:cursor-not-allowed tw:md:top-2 tw:md:left-2 tw:md:z-[1] tw:md:p-2 tw:md:text-[#212121] tw:md:hover:scale-125",
			className,
		)}
		{...props}
	>
		<ArrowLeftIcon className="tw:text-2xl" />
	</Button>
);

PreviousButton.propTypes = {
	handlePrev: PropTypes.func.isRequired,
	className: PropTypes.string,
};
